"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeContent = exports.emptyProposal = exports.ProposalTypes = void 0;
const CarbonSDK_1 = require("../CarbonSDK");
const codec_1 = require("../codec");
const tx_1 = require("../codec/Switcheo/carbon/fee/tx");
const distribution_1 = require("../codec/cosmos/distribution/v1beta1/distribution");
const tx_2 = require("../codec/cosmos/distribution/v1beta1/tx");
const tx_3 = require("../codec/cosmos/gov/v1/tx");
const gov_1 = require("../codec/cosmos/gov/v1beta1/gov");
const params_1 = require("../codec/cosmos/params/v1beta1/params");
const tx_4 = require("../codec/cosmos/upgrade/v1beta1/tx");
const upgrade_1 = require("../codec/cosmos/upgrade/v1beta1/upgrade");
const client_1 = require("../codec/ibc/core/client/v1/client");
const tx_5 = require("../codec/cosmos/auth/v1beta1/tx");
const tx_6 = require("../codec/cosmos/bank/v1beta1/tx");
const tx_7 = require("../codec/cosmos/distribution/v1beta1/tx");
const tx_8 = require("../codec/cosmos/staking/v1beta1/tx");
const tx_9 = require("../codec/cosmos/slashing/v1beta1/tx");
const tx_10 = require("../codec/cosmos/gov/v1/tx");
const tx_11 = require("../codec/Switcheo/carbon/oracle/tx");
var ProposalTypes;
(function (ProposalTypes) {
    // cosmos v1
    ProposalTypes["ParameterChange"] = "/cosmos.params.v1beta1.ParameterChangeProposal";
    ProposalTypes["SoftwareUpgrade"] = "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal";
    ProposalTypes["CancelSoftwareUpgrade"] = "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal";
    ProposalTypes["CommunityPoolSpend"] = "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal";
    ProposalTypes["Text"] = "/cosmos.gov.v1beta1.TextProposal";
    // cosmos v2
    ProposalTypes["CommunityPoolSpendV2"] = "/cosmos.distribution.v1beta1.MsgCommunityPoolSpend";
    ProposalTypes["SoftwareUpgradeV2"] = "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade";
    ProposalTypes["CancelSoftwareUpgradeV2"] = "/cosmos.upgrade.v1beta1.MsgCancelUpgrade";
    // alliance v1
    ProposalTypes["CreateAlliance"] = "/alliance.alliance.MsgCreateAllianceProposal";
    ProposalTypes["UpdateAlliance"] = "/alliance.alliance.MsgUpdateAllianceProposal";
    ProposalTypes["DeleteAlliance"] = "/alliance.alliance.MsgDeleteAllianceProposal";
    // alliance v2
    ProposalTypes["CreateAllianceV2"] = "/alliance.alliance.MsgCreateAlliance";
    ProposalTypes["UpdateAllianceV2"] = "/alliance.alliance.MsgUpdateAlliance";
    ProposalTypes["DeleteAllianceV2"] = "/alliance.alliance.MsgDeleteAlliance";
    // ibc v1
    ProposalTypes["ClientUpdateProposal"] = "/ibc.core.client.v1.ClientUpdateProposal";
    // ibc v2
    // to be added in next cosmos upgrade
    // market v1
    ProposalTypes["UpdateMarket"] = "/Switcheo.carbon.market.UpdateMarketProposal";
    // market v2
    ProposalTypes["UpdateMarketV2"] = "/Switcheo.carbon.market.MsgUpdateMarket";
    // fee v1
    ProposalTypes["SetMsgGasCost"] = "/Switcheo.carbon.fee.SetMsgGasCostProposal";
    ProposalTypes["SetMinGasPrice"] = "/Switcheo.carbon.fee.SetMinGasPriceProposal";
    ProposalTypes["RemoveMsgGasCost"] = "/Switcheo.carbon.fee.RemoveMsgGasCostProposal";
    ProposalTypes["RemoveMinGasPrice"] = "/Switcheo.carbon.fee.RemoveMinGasPriceProposal";
    // fee v2
    ProposalTypes["SetMsgGasCostV2"] = "/Switcheo.carbon.fee.MsgSetGasCost";
    ProposalTypes["SetMinGasPriceV2"] = "/Switcheo.carbon.fee.MsgSetMinGasPrice";
    ProposalTypes["RemoveMsgGasCostV2"] = "/Switcheo.carbon.fee.MsgRemoveGasCost";
    ProposalTypes["RemoveMinGasPriceV2"] = "/Switcheo.carbon.fee.MsgRemoveMinGasPrice";
    // lp v1
    ProposalTypes["UpdatePool"] = "/Switcheo.carbon.liquiditypool.UpdatePoolProposal";
    ProposalTypes["SetRewardCurve"] = "/Switcheo.carbon.liquiditypool.SetRewardCurveProposal";
    ProposalTypes["SetRewardsWeights"] = "/Switcheo.carbon.liquiditypool.SetRewardsWeightsProposal";
    ProposalTypes["SetCommitmentCurve"] = "/Switcheo.carbon.liquiditypool.SetCommitmentCurveProposal";
    // lp v2
    ProposalTypes["UpdatePoolV2"] = "/Switcheo.carbon.liquiditypool.MsgUpdatePool";
    ProposalTypes["SetRewardCurveV2"] = "/Switcheo.carbon.liquiditypool.MsgSetRewardCurve";
    ProposalTypes["SetRewardsWeightsV2"] = "/Switcheo.carbon.liquiditypool.MsgSetRewardsWeights";
    ProposalTypes["SetCommitmentCurveV2"] = "/Switcheo.carbon.liquiditypool.MsgSetCommitmentCurve";
    // pricing v1
    ProposalTypes["SettlementPrice"] = "/Switcheo.carbon.pricing.SettlementPriceProposal";
    // pricing v2
    ProposalTypes["SettlementPriceV2"] = "/Switcheo.carbon.pricing.MsgUpdateSettlementPrice";
    // oracle v1
    ProposalTypes["CreateOracle"] = "/Switcheo.carbon.oracle.CreateOracleProposal";
    // oracle v2
    ProposalTypes["CreateOracleV2"] = "/Switcheo.carbon.oracle.MsgCreateOracle";
    // coin v1
    ProposalTypes["CreateToken"] = "/Switcheo.carbon.coin.CreateTokenProposal";
    ProposalTypes["CreateGroup"] = "/Switcheo.carbon.coin.CreateGroupProposal";
    ProposalTypes["UpdateGroup"] = "/Switcheo.carbon.coin.UpdateGroupProposal";
    ProposalTypes["RegisterToGroup"] = "/Switcheo.carbon.coin.RegisterToGroupProposal";
    ProposalTypes["DeregisterFromGroup"] = "/Switcheo.carbon.coin.DeregisterFromGroupProposal";
    ProposalTypes["DepositToGroup"] = "/Switcheo.carbon.coin.DepositToGroupProposal";
    ProposalTypes["WithdrawFromGroup"] = "/Switcheo.carbon.coin.WithdrawFromGroupProposal";
    ProposalTypes["UpdateGroupTokenConfig"] = "/Switcheo.carbon.coin.UpdateGroupTokenConfigProposal";
})(ProposalTypes = exports.ProposalTypes || (exports.ProposalTypes = {}));
exports.emptyProposal = {
    typeUrl: "",
    value: {},
};
const decodeContent = (content) => {
    if (!content) {
        return exports.emptyProposal;
    }
    let url = content.typeUrl;
    let value = content.value;
    if (url == CarbonSDK_1.CarbonTx.Types.MsgGovExecLegacyContent) {
        // wrapper msg for legacy prop, actual proposal is nested within this
        const wrapperMsg = tx_3.MsgExecLegacyContent.decode(content.value);
        url = wrapperMsg.content.typeUrl;
        value = wrapperMsg.content.value;
    }
    switch (url) {
        case ProposalTypes.ParameterChange:
            return {
                typeUrl: url,
                value: params_1.ParameterChangeProposal.decode(value),
            };
        case ProposalTypes.SoftwareUpgrade:
            return {
                typeUrl: url,
                value: upgrade_1.SoftwareUpgradeProposal.decode(value),
            };
        case ProposalTypes.CancelSoftwareUpgrade:
            return {
                typeUrl: url,
                value: upgrade_1.CancelSoftwareUpgradeProposal.decode(value),
            };
        case ProposalTypes.CommunityPoolSpend:
            return {
                typeUrl: url,
                value: distribution_1.CommunityPoolSpendProposal.decode(value),
            };
        case ProposalTypes.Text:
            return {
                typeUrl: url,
                value: gov_1.TextProposal.decode(value),
            };
        case ProposalTypes.UpdatePool:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.UpdatePoolProposal.decode(value),
            };
        case ProposalTypes.CreateOracle:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Oracle.CreateOracleProposal.decode(value),
            };
        case ProposalTypes.CreateToken:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Coin.CreateTokenProposal.decode(value),
            };
        case ProposalTypes.SetCommitmentCurve:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.SetCommitmentCurveProposal.decode(value),
            };
        case ProposalTypes.SetMsgGasCost:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.SetMsgGasCostProposal.decode(value),
            };
        case ProposalTypes.SetMinGasPrice:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.SetMinGasPriceProposal.decode(value),
            };
        case ProposalTypes.RemoveMsgGasCost:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.RemoveMsgGasCostProposal.decode(value),
            };
        case ProposalTypes.RemoveMinGasPrice:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.RemoveMinGasPriceProposal.decode(value),
            };
        case ProposalTypes.SetRewardCurve:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardCurveProposal.decode(value),
            };
        case ProposalTypes.SetRewardsWeights:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardsWeightsProposal.decode(value),
            };
        case ProposalTypes.SettlementPrice:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Pricing.SettlementPriceProposal.decode(value),
            };
        case ProposalTypes.UpdateMarket:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Market.UpdateMarketProposal.decode(value),
            };
        case ProposalTypes.ClientUpdateProposal:
            return {
                typeUrl: url,
                value: client_1.ClientUpdateProposal.decode(value),
            };
        case ProposalTypes.CreateAlliance:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgCreateAllianceProposal.decode(value),
            };
        case ProposalTypes.UpdateAlliance:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgUpdateAllianceProposal.decode(value),
            };
        case ProposalTypes.DeleteAlliance:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgDeleteAllianceProposal.decode(value),
            };
        // update with new proposal messages
        case ProposalTypes.SetMsgGasCostV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.MsgSetGasCost.decode(value),
            };
        case ProposalTypes.SetMinGasPriceV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.MsgSetMinGasPrice.decode(value),
            };
        case ProposalTypes.RemoveMsgGasCostV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Fee.MsgRemoveGasCost.decode(value),
            };
        case ProposalTypes.RemoveMinGasPriceV2:
            return {
                typeUrl: url,
                value: tx_1.MsgRemoveMinGasPrice.decode(value),
            };
        case ProposalTypes.CommunityPoolSpendV2:
            return {
                typeUrl: url,
                value: tx_2.MsgCommunityPoolSpend.decode(value),
            };
        case ProposalTypes.SoftwareUpgradeV2:
            return {
                typeUrl: url,
                value: tx_4.MsgSoftwareUpgrade.decode(value),
            };
        case ProposalTypes.CancelSoftwareUpgradeV2:
            return {
                typeUrl: url,
                value: tx_4.MsgCancelUpgrade.decode(value),
            };
        case ProposalTypes.CreateAllianceV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgCreateAlliance.decode(value),
            };
        case ProposalTypes.UpdateAllianceV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgUpdateAlliance.decode(value),
            };
        case ProposalTypes.DeleteAllianceV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Alliance.MsgDeleteAlliance.decode(value),
            };
        case ProposalTypes.UpdateMarketV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Market.MsgUpdateMarket.decode(value),
            };
        case ProposalTypes.UpdatePoolV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.MsgUpdatePool.decode(value),
            };
        case ProposalTypes.SetRewardCurveV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.MsgSetRewardCurve.decode(value),
            };
        case ProposalTypes.SetRewardsWeightsV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.MsgSetRewardsWeights.decode(value),
            };
        case ProposalTypes.SetCommitmentCurveV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Liquiditypool.MsgSetCommitmentCurve.decode(value),
            };
        case ProposalTypes.SettlementPriceV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Pricing.MsgUpdateSettlementPrice.decode(value),
            };
        case ProposalTypes.CreateOracleV2:
            return {
                typeUrl: url,
                value: CarbonSDK_1.Carbon.Oracle.MsgCreateOracle.decode(value),
            };
        case codec_1.TxTypes.MsgAuthUpdateParams:
            return {
                typeUrl: url,
                value: tx_5.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgBankUpdateParams:
            return {
                typeUrl: url,
                value: tx_6.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgDistributionUpdateParams:
            return {
                typeUrl: url,
                value: tx_7.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgStakingUpdateParams:
            return {
                typeUrl: url,
                value: tx_8.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgSlashingUpdateParams:
            return {
                typeUrl: url,
                value: tx_9.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgGovUpdateParams:
            return {
                typeUrl: url,
                value: tx_10.MsgUpdateParams.decode(value),
            };
        case codec_1.TxTypes.MsgOracleUpdateParams:
            return {
                typeUrl: url,
                value: tx_11.MsgUpdateParams.decode(value),
            };
        default:
            return exports.emptyProposal;
    }
};
exports.decodeContent = decodeContent;
